import { Link } from '@packages/shared';
import { Logo } from '@packages/themes/icons';
import { defineMessage, useIntl } from 'react-intl';

const logoTitle = defineMessage({
  id: 'logo.title',
  defaultMessage: 'zur Startseite',
});
/** Header tenant logo. Links to home */
export const LinkedLogo = () => {
  const { formatMessage } = useIntl();

  return (
    <Link href="/" noLinkStyle title={formatMessage(logoTitle)}>
      <Logo
        sx={{
          position: 'relative',
          height: [25, 25, 25, 48],
          width: 'auto',
          verticalAlign: 'middle',
        }}
      />
    </Link>
  );
};
